import { useEffect, useState } from "react";
import { resolveOrderAssetUrl } from "@/lib/signedAssets";

interface SignedImageProps {
  src: string;
  alt: string;
  className?: string;
}

export function SignedImage({ src, alt, className }: SignedImageProps) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setFailed(false);
    setUrl(null);
    resolveOrderAssetUrl(src).then((resolved) => {
      if (cancelled) return;
      if (!resolved) setFailed(true);
      else setUrl(resolved);
    });
    return () => {
      cancelled = true;
    };
  }, [src]);

  if (failed) {
    return (
      <div className={`${className ?? ""} flex items-center justify-center bg-muted text-xs text-muted-foreground`}>
        Unable to load
      </div>
    );
  }

  if (!url) {
    return <div className={`${className ?? ""} animate-pulse bg-muted`} />;
  }

  return <img src={url} alt={alt} className={className} />;
}

interface SignedAudioProps {
  src: string;
  className?: string;
}

export function SignedAudio({ src, className }: SignedAudioProps) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    resolveOrderAssetUrl(src).then((resolved) => {
      if (!cancelled) setUrl(resolved);
    });
    return () => {
      cancelled = true;
    };
  }, [src]);

  if (!url) {
    return <div className={`${className ?? ""} h-10 animate-pulse bg-muted rounded`} />;
  }

  return (
    <audio controls className={className}>
      <source src={url} type="audio/webm" />
      <source src={url} type="audio/mp3" />
      Your browser does not support audio playback.
    </audio>
  );
}